<script lang="ts">
  import { getContext } from 'svelte'
  import { fly } from 'svelte/transition'
  import { writable } from 'svelte/store'

  import type { Readable, Writable } from 'svelte/store'

  import MobileMenuItem from './MobileMenuItem.svelte'
  
  export let menu = []
  export let pathChunks: Readable<string[]>
  export let depthStore: Writable<number>

  export let minWidth: number|false = false

  let classString: string|undefined = undefined
  export { classString as class }

  const isPolarityReversed = getContext('isPolarityReversed')
  const menuAnimationDuration = 250

  
  let w: number

  export let show = false
  let actualShow = false
  
  $: if(show) {
    setTimeout(()=> {
      actualShow = true
    }, 10)
  } else {
    actualShow = false
  }
</script>

{#if actualShow}
  <div class="mobile-menu-scroll-wrapper">  
    <ul 
      class="mobile-main-menu block {classString ? ' ' + classString : ''}"
      style:min-width={minWidth ? `${minWidth}px` : '100%'}
      bind:clientWidth={w}
      in:fly={{ x: $isPolarityReversed ? -w : w, duration: menuAnimationDuration, delay: menuAnimationDuration }}
      out:fly={{ x: $isPolarityReversed ? w : -w, duration: menuAnimationDuration }}
      >
      {#if menu.length > 1}
        {#each menu as item}
          <MobileMenuItem {item} {pathChunks} {depthStore} />
        {/each}
      {/if}
    </ul>
  </div>
{/if}

<style lang="postcss">
  ul {
    @apply block top-0 absolute;
  }
</style>